import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
} from "@angular/core";
import { CommentsDataSource } from "../../model/comments-data-source.interface";
import { ButtonType } from "../../model/buttons-config.interface";
import { IComment } from "../comments/comment/comment.component";
import { ModalGalleryService } from "../modal-gallery/modal-gallery.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { InternalLibImage } from "../../model/image-internal.class";

@Component({
  selector: "ks-info-block",
  templateUrl: "./info-block.component.html",
  styleUrls: [
    "./info-block.component.scss",
    "./info-block.component-modern.scss",
  ],
})
export class InfoBlockComponent implements OnInit, OnDestroy {
  @Input() infoTemplate;
  @Input() infoBlockContent;
  @Input() content: ButtonType; // компонент который будет грузиться внутрь инфо блока
  @Input() user: any;

  isOpenComparePhoto: boolean = false;
  comparePhotoUrl: { url: string; from: "comment" | "task" };

  /**
   * DataSource для работы с комментариями
   */
  @Input()
  commentsDataSource: CommentsDataSource;

  /**
   * Id текущей картинки.
   */
  @Input() image: InternalLibImage;

  @Output() resetSizeStyle = new EventEmitter();

  @Output() onClose = new EventEmitter<boolean>();
  @Output() public longerTask: EventEmitter<IComment> = new EventEmitter();

  protected isOpenEditor = signal<boolean>(false);
  protected iSMinScreenLess1600 = signal<boolean>(false);

  constructor(private modalGalleryService: ModalGalleryService) {
    this.modalGalleryService
      .getStatusEditor()
      .pipe(takeUntilDestroyed())
      .subscribe((isOpen) => {
        this.isOpenEditor.set(isOpen);
        if (isOpen) {
          this.isOpenComparePhoto = false;
        }
      });
  }

  ngOnInit() {
    this.resetSizeStyle.emit();
    const initWidthScreen = window.innerWidth;
    this.iSMinScreenLess1600.set(initWidthScreen < 1600);
  }

  ngOnDestroy() {
    this.onClose.emit(true);
  }

  close() {
    this.onClose.emit(true);
    this.modalGalleryService.clearPhotoToSend();
  }
  longTask(comment: IComment) {
    this.longerTask.emit(comment);
  }

  onComparePhoto(url: { url: string; from: "comment" | "task" }) {
    console.log("onComparePhoto-info", url);
    // this.longerTask.emit(comment);
    this.isOpenComparePhoto = true;
    this.comparePhotoUrl = url;
    this.modalGalleryService.onCloseEditor();
  }

  closeComparePhoto() {
    this.isOpenComparePhoto = false;
  }
}
